import { addBlockDesignObjectType } from './add-block-type.util';
import { DesignTypeEnum } from '../../../enum/design-type.enum';
import { IBlockDataModelConstructor } from '../../../interface/block/block-data-contructor.interface';

export function webDocumentBlock(blockDataModel: IBlockDataModelConstructor) {
  return addBlockDesignObjectType(blockDataModel, DesignTypeEnum.WebDocument);
}
